import { useState } from "react";
import axios from "axios";
import { useAuthContext } from "../../hooks/useAuthContext";
import "./Login.css";
import { Link } from "react-router-dom";
import { ApiConnectionString } from "../../constants/ApiConntection";
import ForgotPasswordModal from "./modals/ForgotPasswordModel";
import LoadingSpinner from "../../components/LoadingSpinner";
import MemboticLogo from "../../assets/MemboticLogo.png";

export default function Login() {
  const [password, setPassword] = useState("");
  const [username, setUsername] = useState("");
  const [loginErr, setLoginErr] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { dispatch } = useAuthContext();
  const [forgotPasswordModal, setForgotPasswordModal] = useState(false);

  const cancelModel = () => {
    setForgotPasswordModal(false);
  };

  const handleSubmit = (e) => {
    setSubmitting(true);
    e.preventDefault();
    if (username.length === 0 || password.length === 0) {
      setLoginErr("Username and password must both be filled in");
      return;
    }
    const loginDetails = { username, password };

    axios
      .post(`${ApiConnectionString}/api/users/login/`, loginDetails)
      .then((res) => {
        if (res.status === 200) {
          dispatch({ type: "LOGIN", payload: res.data });
        }
      })
      .catch((err) => {
        if (err.response.status === 400) {
          setLoginErr(err.response.data[0]);
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  if (submitting) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  } else {
    return (
      <div>
        <form onSubmit={handleSubmit} className="login-form">
          <div className="text-center">
            {" "}
            <img
              src={MemboticLogo}
              className="login-logo"
              alt="Membotic"
              title="Membotic"
            />
          </div>

          <p className="text-center">Log in to Membotic to continue</p>
          <label>
            <input
              className="height"
              onChange={(e) => setUsername(e.target.value)}
              value={username}
              placeholder="Username or Email*"
            />
          </label>
          <label>
            <input
              className="height"
              type={showPassword ? "text" : "password"}
              onChange={(e) => setPassword(e.target.value)}
              value={password}
              placeholder="Password*"
            />
          </label>
          {loginErr && <p className="text-danger">{loginErr}</p>}
          <div className="d-flex m-1">
            <input
              className="m-0 customCheck"
              type="checkbox"
              checked={showPassword}
              onChange={() => setShowPassword(!showPassword)} // Toggle state
            />

            <p
              onClick={() => setShowPassword(!showPassword)}
              className="px-3 m-0 py-0 pointer"
            >
              Show Password
            </p>
          </div>

          <div className="text-center">
            <button className="btn btn-primary btn-lg my-2">Continue</button>
          </div>
          <p
            onClick={() => {
              setForgotPasswordModal(true);
            }}
            className="text-primary cursor-pointer"
          >
            Forgot Password?
          </p>
          <div className="d-flex">
            <p>Not a member?</p>

            <Link
              onClick={() => window.scrollTo(0, 0)}
              to="/Register"
              className="text-decoration-none mx-2"
            >
              Signup Now
            </Link>
          </div>
        </form>
        {forgotPasswordModal && (
          <ForgotPasswordModal cancelModal={cancelModel} />
        )}
      </div>
    );
  }
}
